import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { api, img, money } from "../../lib/api";
import { useLang } from "../../context/LangContext";

export const SearchDialog = ({ open, onOpenChange }) => {
  const { t, L } = useLang();
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);

  useEffect(() => {
    if (q.trim().length < 2) {
      setRes([]);
      return;
    }
    const id = setTimeout(() => api.get("/products", { params: { q, limit: 8 } }).then((r) => setRes(r.data)), 250);
    return () => clearTimeout(id);
  }, [q]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="top-[12%] max-w-2xl translate-y-0 rounded-none border-sand bg-ivory p-0">
        <DialogTitle className="sr-only">{t("search")}</DialogTitle>
        <div className="flex items-center gap-3 border-b border-sand px-6">
          <Search size={18} strokeWidth={1.4} className="text-sand-dark" />
          <input autoFocus data-testid="search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("search_ph")}
            className="h-16 w-full bg-transparent text-lg outline-none placeholder:text-sand-dark" />
        </div>
        <div className="max-h-[60vh] overflow-y-auto p-3">
          {q.length >= 2 && res.length === 0 && <p className="p-6 text-sm text-sand-dark">{t("no_results")}</p>}
          {res.map((p) => (
            <Link key={p.id} to={`/product/${p.slug}`} onClick={() => onOpenChange(false)} data-testid={`search-result-${p.slug}`}
              className="flex items-center gap-4 p-3 transition-colors hover:bg-sand-light">
              <img src={img(p.images?.[0])} alt="" className="h-16 w-12 object-cover" />
              <span className="flex-1 text-sm">{L(p, "name")}</span>
              <span className="text-sm">{money(p.final_price)} {t("sar")}</span>
            </Link>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
